var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainWrapperApp"}},[_c('Header'),_c('router-view',{staticStyle:{"animation-duration":"0.2s"}}),_c('Footer'),_c('GoTop',{attrs:{"boundary":10,"size":45,"bg-color":"#6666","bottom":30,"right":'94%'}}),_c('FormWidget')],1)}
var staticRenderFns = []

export { render, staticRenderFns }